/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
// tslint:disable-next-line: no-duplicate-imports
import { IActionContext } from '@msdyn365-commerce/core';
import { CacheType } from '@msdyn365-commerce/retail-proxy';
import { mFIGetAvailablePromotionsDescriptionAsync } from './EyebrowMessageDataActionExtension.g';
import { IMFIAvailablePromotionDescription, IMFIPromotion } from './EyebrowMessageDataServiceEntities.g';
/**
 * GetEyebrowMessage Input Action
 */

export class GetEyebrowMessageInput implements Msdyn365.IActionInput {
    //   Construct the input needed to run the action
    public item: IMFIAvailablePromotionDescription;
    public isCached?: boolean;
    public pageType?: string;
    private readonly createCacheKey: string | '';
    constructor(item: IMFIAvailablePromotionDescription, pageType?: string, isCached?: boolean) {
        this.item = item;
        this.isCached = isCached;
        this.pageType = pageType;
        // incase of pdp cache key will be based on variantId and on PLP will be basded on ItemId
        this.createCacheKey =
            this.item.Items?.map(obj => (this.pageType === 'pdp' ? obj?.DistinctProductVariant : obj?.ItemId))
                .join('-')
                .toString() || '';
    }

    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `Get-Eyebrow-Message-${this.createCacheKey}`;
    // public getCacheKey = () => 'EyebrowMessage';
    public getCacheObjectType = () => 'EyebrowMessage';
    public dataCacheType = (): CacheType => (this.isCached ? 'application' : 'application');
}

//   Create a data model here or import one to capture the response of the action

/**
 *   Use this function to create the input required to make the action call
 */

/**
 *   Use this function to call your action and process the results as needed
 */
async function getEyebrowAction(input: GetEyebrowMessageInput, ctx: IActionContext): Promise<IMFIPromotion[] | null> {
    try {
        const result = await mFIGetAvailablePromotionsDescriptionAsync(
            { callerContext: ctx, queryResultSettings: { Paging: { Top: 50 } } },
            input.item
        );
        if (result) {
            return result;
        }
    } catch (error) {
        console.log('Error', error);
    }
    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IMFIPromotion[] | null>>getEyebrowAction,
    //   Give your data action a unique id
    id: 'GetEyebrowMessage'
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
